import burgerBackground from '../assets/images/labels/headers/burger.jpg';
import foundationBackground from '../assets/images/labels/headers/foundation.jpg';
import golfChannelBackground from '../assets/images/labels/headers/golf-channel.jpg';
import minimalWaveBackground from '../assets/images/labels/headers/minimal-wave.jpg';
import plantBackground from '../assets/images/labels/headers/plant.jpg';
import ppuBackground from '../assets/images/labels/headers/ppu.jpg';
import rockersBackground from '../assets/images/labels/headers/rockers.jpg';
import soundwayBackground from '../assets/images/labels/headers/soundway.jpg';
import stonesThrowBackground from '../assets/images/labels/headers/stones-throw.jpg';
import workshopBackground from '../assets/images/labels/headers/workshop.jpg';

import burgerLogo from '../assets/images/labels/logos/burger.svg';
import foundationLogo from '../assets/images/labels/logos/foundation.svg';
import golfChannelLogo from '../assets/images/labels/logos/golf-channel.svg';
import minimalWaveLogo from '../assets/images/labels/logos/minimal-wave.svg';
import plantLogo from '../assets/images/labels/logos/plant.svg';
import ppuLogo from '../assets/images/labels/logos/ppu.svg';
import rockersLogo from '../assets/images/labels/logos/rockers.svg';
import soundwayLogo from '../assets/images/labels/logos/soundway.svg';
import stonesThrowLogo from '../assets/images/labels/logos/stones-throw.svg';
import workshopLogo from '../assets/images/labels/logos/workshop.svg';

import burgerDisk from '../assets/images/labels/products/burger.jpg';
import foundationDisk from '../assets/images/labels/products/foundation.jpg';
import golfChannelDisk from '../assets/images/labels/products/golf-channel.jpg';
import minimalWaveDisk from '../assets/images/labels/products/minimal-wave.jpg';
import plantDisk from '../assets/images/labels/products/plant.jpg';
import ppuDisk from '../assets/images/labels/products/ppu.jpg';
import rockersDisk from '../assets/images/labels/products/rockers.jpg';
import soundwayDisk from '../assets/images/labels/products/soundway.jpg';
import stonesThrowDisk from '../assets/images/labels/products/stones-throw.jpg';
import workshopDisk from '../assets/images/labels/products/workshop.jpg';

import burgerHat from '../assets/images/labels/products/burger-hat.jpg';
import foundationHat from '../assets/images/labels/products/foundation-hat.jpg';
import golfChannelHat from '../assets/images/labels/products/golf-channel-hat.jpg';
import minimalWaveHat from '../assets/images/labels/products/minimal-wave-hat.jpg';
import plantHat from '../assets/images/labels/products/plant-hat.jpg';
import ppuHat from '../assets/images/labels/products/ppu-hat.jpg';
import rockersHat from '../assets/images/labels/products/rockers-hat.jpg';
import soundwayHat from '../assets/images/labels/products/soundway-hat.jpg';
import stonesThrowHat from '../assets/images/labels/products/stones-throw-hat.jpg';
import workshopHat from '../assets/images/labels/products/workshop-hat.jpg';

export default {
  foundation: {
    header: foundationBackground,
    logo: foundationLogo,
    logoSize: 160,
    hat: {
      image: foundationHat,
      title: 'Tropic Bombin White',
      subtitle: 'Kangol'
    },
    disk: {
      image: foundationDisk,
      title: 'Haemongyang',
      subtitle: 'Hyoo'
    },
    urls: {
      homepage: { url: 'http://fndt.co.kr/', title: 'Foundation Homepage' },
      twitter: { url: 'https://twitter.com/fndt_kr', title: 'Foundation on Twitter' },
      facebook: { url: 'https://www.facebook.com/foundationkr', title: 'Foundation on Facebook' }
    },
    title: 'Foundation',
    subtitle: '—Experimental',
    moreInfo: 'Seoul',
    description: "Foundation Records is a pioneering independent Korean record label established in Seoul in 2005 by Hyun-Joon Cho (a.k.a HJ). Cho received his start by launching Afroking, a promotion company that led Korea's club and party culture. The label strives to work with talented artists spanning all cultural platforms relating to music, laying the foundation for vocalists, music producers, DJs, and visual artists."
  },
  burger: {
    header: burgerBackground,
    logo: burgerLogo,
    logoSize: 141,
    hat: {
      image: burgerHat,
      title: 'Tropic Ventair Spacecap Marine',
      subtitle: 'Kangol'
    },
    disk: {
      image: burgerDisk,
      title: 'Brain Cream',
      subtitle: 'Jail'
    },
    urls: {
      homepage: { url: 'http://www.burgerrecords.org', title: 'Burger Homepage' },
      twitter: { url: 'https://twitter.com/burgerrecords', title: 'Burger on Twitter' },
      facebook: { url: 'https://www.facebook.com/burgerrecords', title: 'Burger on Facebook' }
    },
    title: 'Burger',
    subtitle: '—LO-FI',
    moreInfo: 'LA',
    description: "Burger Records is a cult rock 'n' roll independent label and record store born and bred in California. Lee Rickard and Sean Bohrman started the label in 2007 before opening a store by the same name in 2009. From there, Burger Records expanded to pop-up festivals like Burgerama in Orange County, CA, Burger Boogaloo in Oakland, CA, Burgermania in Austin, TX and more, with additional shows and tours happening weekly. Burger Records has launched its own TV station called BRGRTV, The Burger Records Rock N Roll Radio Show podcast, and GnarBurger, the recently opened Los Angeles store and art gallery space."
  },
  'golf-channel': {
    header: golfChannelBackground,
    logo: golfChannelLogo,
    logoSize: 177,
    hat: {
      image: golfChannelHat,
      title: 'Marker Pen Reversible Bucket',
      subtitle: 'Kangol'
    },
    disk: {
      image: golfChannelDisk,
      title: 'Paradise',
      subtitle: 'Payfone'
    },
    urls: {
      homepage: { url: 'http://www.golfchannelrecordings.com', title: 'Golf Channel Homepage' },
      twitter: { url: 'https://twitter.com/MidnightTetley', title: 'Golf Channel on Twitter' },
      facebook: { url: 'https://www.facebook.com/GolfChannelRecordings', title: 'Golf Channel on Facebook' }
    },
    title: 'Golf Channel',
    subtitle: '—House',
    moreInfo: 'NYC',
    description: "Born in the intoxicating stream from a smoke machine and to the pulse of a strobe light of one of NYC's most respected and craziest parties (No Ordinary Monkey) Golf Channel Recordings was established in 2007 and quickly became known as a label with a strong aesthetic and a diverse sound. Label head Phil South runs the label  with a DIY ethic that champions an eclectic diverse movement including well-respected albums across house, Afro dub techno, anarchist acid breakbeat, widescreen psychedelia and boogie drenched muscle pop."
  },
  'minimal-wave': {
    header: minimalWaveBackground,
    logo: minimalWaveLogo,
    logoSize: 155,
    hat: {
      image: minimalWaveHat,
      title: 'Bamboo Mowbray Black',
      subtitle: 'Kangol'
    },
    disk: {
      image: minimalWaveDisk,
      title: 'H.S.T.A.',
      subtitle: 'Das Ding'
    },
    urls: {
      homepage: { url: 'http://www.minimalwave.com', title: 'Minimal Wave Homepage' },
      twitter: { url: 'https://twitter.com/Minimal_Wave', title: 'Minimal Wave on Twitter' },
      facebook: { url: 'https://www.facebook.com/groups/96343456988/', title: 'Minimal Wave on Facebook' }
    },
    title: 'Minimal Wave',
    subtitle: '—Synth',
    moreInfo: 'NYC',
    description: "Founded by DJ and East Village Radio host Veronica Vasicka in 2005, New York-based label Minimal Wave has unearthed an entire subgenre from the past and repackaged it for a new generation. Due to a resurgence of interest created by Minimal Wave releases, many bands have reformed to record new music and play live again generating a network for synth wave enthusiasts and promoting electronic music via an online archive and high-quality vinyl releases."
  },
  plant: {
    header: plantBackground,
    logo: plantLogo,
    logoSize: 157,
    hat: {
      image: plantHat,
      title: 'Bamboo Spacecap Sergeant',
      subtitle: 'Kangol'
    },
    disk: {
      image: plantDisk,
      title: 'Useful For Mind',
      subtitle: 'DJ Yasa'
    },
    urls: {
      homepage: { url: 'http://www.plantrec.com/', title: 'Plant Records Homepage' },
      twitter: { url: 'https://twitter.com/PLANTRECORDS', title: 'Plant Records on Twitter' },
      facebook: { url: 'https://www.facebook.com/plantrec', title: 'Plant Records on Facebook' }
    },
    title: 'Plant Records',
    subtitle: '—Hip-Hop',
    moreInfo: 'Osaka',
    description: "Plant Records is headed by legendary turntable unit Kireek (DJ Yasa and DJ Hi-C), Plant Records is headed by legendary turntable unit Kireek (DJ Yasa and DJ Hi-C), DMC World DJ Championships winners from 2007 to 2011. A year after winning in 2011 with the first unanimous decision by the judges for a perfect score, they launched Plant Records with a commitment to release music and promote DJs of all genres that have turntable rhythm as the foundation of their philosophy."
  },
  ppu: {
    header: ppuBackground,
    logo: ppuLogo,
    logoSize: 188,
    hat: {
      image: ppuHat,
      title: 'Tropic Ventair 504 Navy',
      subtitle: 'Kangol'
    },
    disk: {
      image: ppuDisk,
      title: 'Born With A Desire',
      subtitle: 'Tony Palkovic'
    },
    urls: {
      homepage: { url: 'http://ppudc.com', title: 'PPU Records Homepage' },
      facebook: { url: 'https://www.facebook.com/pages/PPU-Peoples-Potential-Unlimited', title: 'PPU Records on Facebook' }
    },
    title: 'PPU Records',
    subtitle: '—Funk/Soul',
    moreInfo: 'DC',
    description: "People's Potential Unlimited (PPU) is a record label in DC known for discovering and reissuing some of the weirdest and best ultra-rare boogie, funk, and other dance music from the 70s, 80s and 90s, as well as a new generation of beat-makers who draw sonic inspiration from these worlds of sound. Founded by Andrew Morgan and originally operating out of his basement, PPU creates a world that re-imagines funk as outsider art. The label's roster includes names found on demo tapes abandoned in time, but also pushes the present into the future with newly discovered acts."
  },
  rockers: {
    header: rockersBackground,
    logo: rockersLogo,
    logoSize: 181,
    hat: {
      image: rockersHat,
      title: 'Digi Marble Casual Black',
      subtitle: 'Kangol'
    },
    disk: {
      image: rockersDisk,
      title: 'King David\'s Melody',
      subtitle: 'Augustus Pablo'
    },
    urls: {
      facebook: { url: 'https://www.facebook.com/rockersinternational', title: 'Rockers Intl on Facebook' }
    },
    title: 'Rockers Intl',
    subtitle: '—Reggae',
    moreInfo: 'Kingston',
    description: "The late Augustus Pablo originally opened Rockers International in downtown Kingston, Jamaica as a record store in 1979 which remains the only store from the era still open today. Pablo built his reputation as a top reggae producer with his distinctive and often minor-key dominated sounds, as well as being music's first true melodica specialist. His distinctive sound carried over to his record label launched soon after, releasing numerous genre-setting reggae recordings from the 70s through the 90s. Today, the Rockers International record store acts as a landmark for music enthusiasts while the label produces new releases, original projects and vinyl reissues."
  },
  soundway: {
    header: soundwayBackground,
    logo: soundwayLogo,
    logoSize: 146,
    hat: {
      image: soundwayHat,
      title: 'British Peebles Tan',
      subtitle: 'Kangol'
    },
    disk: {
      image: soundwayDisk,
      title: 'Sierra Leone in 1970s USA',
      subtitle: 'Muyei Power'
    },
    urls: {
      homepage: { url: 'http://www.soundwayrecords.com', title: 'Soundway Homepage' },
      twitter: { url: 'https://twitter.com/Soundway', title: 'Soundway on Twitter' },
      facebook: { url: 'http://www.facebook.com/SoundwayRecords', title: 'Soundway on Facebook' }
    },
    title: 'Soundway',
    subtitle: '—Global Dance',
    moreInfo: 'London',
    description: "Label owner Miles Cleret conceived Soundway Records in 2002 during a trip from Ghana  during which he unearthed dusty 45s and LPs that had not been heard outside the former Gold Coast since their original releases. Soundway's early releases included Afro-beat Funk & Fusion from 70s Ghana and featured many of the artists Cleret met on his inaugural trip to West Africa. Although the label has it's roots in West Africa, the scope has grown to include other regions of the tropical belt and continues to issue and re-issue recordings of obscure original Afro-Jazz, Afro-Funk, and Latin-Jazz artists."
  },
  workshop: {
    header: workshopBackground,
    logo: workshopLogo,
    logoSize: 181,
    hat: {
      image: workshopHat,
      title: 'Tropic Hardee Black',
      subtitle: 'Kangol'
    },
    disk: {
      image: workshopDisk,
      title: 'Workshop 02',
      subtitle: 'Move D Feat. DJ Late'
    },
    urls: {
      homepage: { url: 'http://www.workshopsound.com/', title: 'Workshop Homepage' },
      facebook: { url: 'https://www.facebook.com/pages/Workshop-Records/319615584057', title: 'Workshop on Facebook' }
    },
    title: 'Workshop',
    subtitle: '—Techno',
    moreInfo: 'Berlin',
    description: "Launched in 2006 by Jens Kuhn (Lowtec) and Paul David Rollmann (Even Tuell), Workshop has become one of the most exciting and genre-defining underground house and techno labels of recent years. Seeing success with its minimalistic hand-stamped aesthetic, little-to-no advertising and free artistic expression, the label represents a warm, unconventional, focused and intelligent perspective on dance music and it constantly explores the edges and intersections to dance music's surrounding genres."
  },
  'stones-throw': {
    header: stonesThrowBackground,
    logo: stonesThrowLogo,
    logoSize: 138,
    hat: {
      image: stonesThrowHat,
      title: 'Bermuda Casual White',
      subtitle: 'Kangol'
    },
    disk: {
      image: stonesThrowDisk,
      title: 'Yawn Zen',
      subtitle: 'MNDSGN'
    },
    urls: {
      homepage: { url: 'http://www.stonesthrow.com/', title: 'Stones Throw Homepage' },
      twitter: { url: 'https://twitter.com/stonesthrow', title: 'Stones Throw on Twitter' },
      facebook: { url: 'https://www.facebook.com/stonesthrow', title: 'Stones Throw on Facebook' }
    },
    title: 'Stones Throw',
    subtitle: '—Hip-Hop',
    moreInfo: 'LA',
    description: "Under the direction of founder and world-renowned DJ Peanut Butter Wolf, Stones Throw has consistently released critically acclaimed, left-of-center albums since its inception in 1996. The LA-based label is considered one of the leading names in underground hip-hop circles with a cult fan following around the world. Applauded as a risk taking, genre-bending imprint, Stones Throw not only is a top tier tastemaker for hip hop releases, but has built an extraordinary reputation for its soul, electro, disco, and psychedelia releases."
  }
};


/** WEBPACK FOOTER **
 ** ./src/playlists/labels.es6
 **/